import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { FaTrashAlt, FaArrowLeft } from 'react-icons/fa';
import {
  Table,
  Form,
  Card,
  Button,
  Dropdown,
  Modal,
  Spinner,
  Badge,
} from 'react-bootstrap';
import { selectProntuarioById } from '../../redux/features/prontuario/prontuarioSlice';
import api from '../../services/api';
import history from '../../services/history';
import { dbatividade } from '../../helpers/agenda/convenios';
import CustomFileInput from '../../components/CustomFileInput';
import ReceituarioMedico from '../../pages/receita/ReceituarioMedico';
import { getStatusBadgeVariant } from '../../util/agendaHelpers';
import useUploadFiles from '../../hooks/useUploadFiles';
import PacienteInfo from '../../components/paciente/PacienteInfo';
import selectEcoById from '../../services/ecodoppler';
import generateCongTXTPDF from '../laudo/eco/generateCongTXTPDF';
import isMedicoExterno from '../../util/medicoHelpers';

export default function Atividade() {
  const dispatch = useDispatch();
  const location = useLocation();
  const medico = useSelector(state => state.doctor.profile);
  const { funcionario } = useSelector(state => state.funcionario);
  const searchParams = new URLSearchParams(location.search);
  const [pacientes, setPacientes] = useState([]);
  const [atividades, setAtividades] = useState([]);
  const [search, setSearch] = useState(false);
  const [nomePac, setNomePac] = useState('');
  const [dtnNasc, setDtnNasc] = useState('');
  const [cpf, setCpf] = useState('');
  const [atividade, setAtividade] = useState();
  const [showReceitaModal, setShowReceitaModal] = useState(false);
  const [showPaciente, setShowPaciente] = useState(false);
  const [pacienteSelecionado, setPacienteSelecionado] = useState(null);
  const [isLocalizando, setIsLocalizando] = useState(false);
  const [loadingAtividadeId, setLoadingAtividadeId] = useState(null);
  const [loadingPacienteId, setLoadingPacienteId] = useState(null);
  const {
    files,
    setFiles,
    showUpload,
    setShowUpload,
    isUploading,
    confirmUpload,
    handleCloseModal,
  } = useUploadFiles({ atividade });

  useEffect(() => {
    const searchParams = new URLSearchParams(history.location.search);
    const userId = searchParams.get('userId');
    const patientName = searchParams.get('pacName');
    if (patientName) handleAtividades({ CODPAC: userId, NOMEPAC: patientName });
  }, [history.location.search]);

  async function handleImprimir(atividade, printing = false) {
    switch (atividade.CODPROCEDI) {
      case 1:
      case 58:
      case 800:
        handleProntuario(atividade);
        break;
      case 3:
        handleEcg(atividade);
        break;
      case 6: // HOLTER
      case 820: // HOLTER24h
        handleHolter(atividade);
        break;
      case 7: // MAPA
      case 810:
        if (atividade.GUIA1 === 'SIM') {
          history.push(`/reportMapa/${atividade.CODLAUDO}`);
        } else {
          toast.warn('Laudo não Liberado para Internet!');
        }
        break;
      case 13:
        handleStress(atividade);
        break;
      case 12:
        handleTrans(atividade);
        break;
      case 4:
        handleErgo(atividade, printing);
        break;
      case 11:
      case 712:
      case 713:
      case 714:
        handleEco(atividade, printing);
        break;
      case 14:
      case 15:
        handleCarotida(atividade, printing);
        break;
      case 17:
        handleFetal(atividade);
        break;
      default:
        return toast.warn('Laudo não disponível para Visualização!');
    }
  }

  async function handleImprimirTXT(atividade) {
    if (![11, 712, 713, 714].includes(atividade.CODPROCEDI)) {
      return toast.warn('Laudo não disponível!');
    }

    try {
      setLoadingAtividadeId(atividade.CODLAUDO);
      if (isMedicoExterno(medico)) {
        // SANTA CASA
        if (dbatividade.convenios.some(c => c.codConv === atividade.CODCONV)) {
          if (atividade.GUIA1 === 'SIM') {
            const eco = await selectEcoById(atividade.CODLAUDO);
            if (eco?.TIPOECO === 'EcoC') {
              if (eco.CODREALIZOU === 4860) {
                history.push(`/formCongenitoTXT/${atividade.CODLAUDO}`);
              } else {
                history.push(`/reportEcoCongenito/${atividade.CODLAUDO}`);
              }
            } else {
              history.push(`/reportDoppler/${eco?.CODECO}`);
            }
          } else {
            toast.warn('Laudo não Liberado para Internet!');
          }
        } else {
          toast.warn('Convênio não Autorizado!');
        }
      } else if (medico?.tipo === 'Agenda') {
        if (atividade.GUIA1 === 'SIM') {
          const eco = await selectEcoById(atividade.CODLAUDO);
          if (eco?.TIPOECO === 'EcoC') {
            if (eco.CODREALIZOU === 4860) {
              await generateCongTXTPDF(eco, 'imprimirNormal', 1);
            } else {
              history.push(`/reportEcoCongenito/${atividade.CODLAUDO}`);
            }
          } else {
            toast.warn('Disponível para Laudo de Eco Congênito!');
          }
        } else {
          toast.warn('Laudo não liberado para Internet!');
        }
      } else {
        toast.warn('Visualização não permitida. Consulte a administração!');
      }
    } catch (error) {
      toast.error('Erro ao carregar laudo!');
    } finally {
      setLoadingAtividadeId(null);
    }
  }

  async function handleLaudarCongenitoTXT(atividade) {
    // TODO/NOTA: pai, pq nao usar só o handeLaudar? NEUSA MARTINS MACHADO - Med EcgExt - 7 de janeiro de 2026
    // aqui fica só carregando... ???
    history.push(`/formCongenitoTXT/${atividade.CODLAUDO}`);
  }

  async function handleLaudar(atividade) {
    setLoadingAtividadeId(atividade.CODLAUDO);
    try {
      if (medico?.tipo === 'Agenda' || funcionario) {
        switch (atividade.CODPROCEDI) {
          case 1:
          case 58:
          case 800:
            await dispatch(selectProntuarioById(atividade.CODLAUDO));
            history.push('/formProntuario');
            break;
          case 3:
            history.push(`/formEcg/${atividade.CODLAUDO}`);
            break;
          case 820: // HOLTER24H
          case 6: // HOLTER
            history.push(`/reportHolter/${atividade.CODLAUDO}`);
            break;
          case 810:
          case 7:
            history.push(`/reportMapa/${atividade.CODLAUDO}`);
            break;
          case 13:
            history.push('/formStress', {
              codLaudo: atividade.CODLAUDO,
              medico: medico,
            });
            break;
          case 12:
            history.push(`/form-trans/${atividade.CODLAUDO}`);
            break;
          case 4:
            history.push(`/formErgo/${atividade.CODLAUDO}`);
            break;
          case 11:
          case 712:
          case 713:
          case 714:
            try {
              const eco = await selectEcoById(atividade.CODLAUDO);
              if (eco?.TIPOECO === 'EcoC')
                history.push(`/formCongenito/${atividade.CODLAUDO}`);
              else history.push(`/formDoppler/${atividade.CODLAUDO}`);
            } catch (error) {
              toast.error(
                error?.response?.data?.error || 'Erro ao carregar laudo!'
              );
            }
            break;
          case 14:
          case 15:
            history.push(`/form-carotida/${atividade.CODLAUDO}`);
            break;
          case 17:
            history.push('/form-fetal', { codLaudo: atividade.CODLAUDO });
            break;
          default:
            return toast.warn('Laudo não disponível para registro!');
        }
      }
    } finally {
      setLoadingAtividadeId(null);
    }
  }

  function handleAtividades({ CODPAC, NOMEPAC }) {
    setLoadingPacienteId(CODPAC);

    searchParams.set('userId', CODPAC);
    searchParams.set('pacName', NOMEPAC);

    api
      .get(`pacientes/${CODPAC}/atividades`)
      .then(result => {
        setAtividades(result.data);
        setSearch(true);
        history.push(`/frmatv?${searchParams.toString()}`);
      })
      .catch(err =>
        toast.error(err.response.data.error || 'Erro ao carregar atividades!')
      )
      .finally(() => setLoadingPacienteId(null));
  }

  async function handleProntuario(atividade) {
    setLoadingAtividadeId(atividade.CODLAUDO);
    try {
      if (atividade.GUIA1 === 'SIM') {
        // SANTA CASA
        await dispatch(selectProntuarioById(atividade.CODLAUDO));
        history.push('/formProntuario');
      } else {
        toast.warn('Prontuário não Autorizado!');
      }
    } finally {
      setLoadingAtividadeId(null);
    }
  }

  function handleEcg(atividade) {
    if (atividade.GUIA1 === 'SIM') {
      history.push(`/reportEcg/${atividade.CODLAUDO}`);
    } else {
      toast.warn('Laudo não Liberado para Internet!');
    }
  }

  function handleHolter(atividade) {
    // LAUDO LIBERADO (SIM ou NAO)
    if (atividade.GUIA1 === 'SIM') {
      history.push(`/reportHolter/${atividade.CODLAUDO}`);
    } else {
      toast.warn('Laudo não Liberado para Internet!');
    }
  }

  async function handleBuscarPacientes() {
    if (nomePac.length < 3 && cpf.length !== 11 && dtnNasc.length < 3) {
      return toast.warn('Preencha pelo menos um campo!');
    }
    if (nomePac.length > 0 && nomePac.length < 3) {
      return toast.warn('Nome deve ter pelo menos 3 letras!');
    }
    if (cpf.length > 0 && cpf.length !== 11) {
      return toast.warn('CPF deve ter 11 dígitos!');
    }
    if (dtnNasc.length > 0 && dtnNasc.length < 3) {
      return toast.warn('Data de nascimento deve ter pelo menos 3 caracteres!');
    }

    try {
      setIsLocalizando(true);

      const searchParams = {};
      if (nomePac.trim()) searchParams.nome = nomePac.trim();
      if (cpf.trim()) searchParams.cpf = cpf.trim();
      if (dtnNasc.trim()) searchParams.dtNasc = dtnNasc.trim();

      const { data } = await api.get('/pacientes', { params: searchParams });

      setPacientes(data);
      setSearch(false);
    } catch (error) {
      toast.error(error?.response?.data?.error || 'Erro ao buscar pacientes!');
    } finally {
      setIsLocalizando(false);
    }
  }

  async function handleStress(atividade) {
    if (atividade.GUIA1 !== 'SIM') return toast.warn('Laudo não autorizado!');

    history.push('/formStress', {
      codLaudo: atividade.CODLAUDO,
      medico,
    });
  }

  async function handleTrans(atividade) {
    if (atividade.GUIA1 !== 'SIM') return toast.warn('Laudo não Autorizado!');

    history.push(`/report-trans/${atividade.CODLAUDO}`);
  }

  async function handleErgo(atividade, printing = false) {
    if (atividade.GUIA1 === 'SIM') {
      history.push({
        pathname: `/reportErgo/${atividade.CODLAUDO}`,
        state: { printing },
      });
    } else {
      toast.warn('Laudo não Autorizado!');
    }
  }

  async function handleEco(atividade, printing = false) {
    setLoadingAtividadeId(atividade.CODLAUDO);
    try {
      if (isMedicoExterno(medico)) {
        // SANTA CASA
        if (dbatividade.convenios.some(c => c.codConv === atividade.CODCONV)) {
          // LAUDO LIBERADO (SIM ou NAO)
          if (atividade.GUIA1 === 'SIM') {
            const eco = await selectEcoById(atividade.CODLAUDO);
            if (eco?.TIPOECO === 'EcoC') {
              if (eco.CODREALIZOU === 4860) {
                // history.push(`/formCongenitoTXT/${atividade.CODLAUDO}`);
                await generateCongTXTPDF(eco, 'imprimirTimbrado', 1);
              } else {
                history.push({
                  pathname: `/reportEcoCongenito/${atividade.CODLAUDO}`,
                  state: { printing },
                });
              }
            } else {
              history.push({
                pathname: `/reportDoppler/${eco?.CODECO}`,
                state: { printing },
              });
            }
          } else {
            toast.warn('Laudo não Liberado para Internet!');
          }
        } else {
          toast.warn('Convênio não Autorizado!');
        }
      } else if (medico?.tipo === 'Agenda') {
        // if (medico.codMed NAO FOR DA SANTA CASA (SE FOR DA EQUIPE))
        if (atividade.GUIA1 === 'SIM') {
          const eco = await selectEcoById(atividade.CODLAUDO);
          if (eco?.TIPOECO === 'EcoC') {
            if (eco.CODREALIZOU === 4860) {
              await generateCongTXTPDF(eco, 'imprimirTimbrado', 1);
            } else {
              history.push({
                pathname: `/reportEcoCongenito/${atividade.CODLAUDO}`,
                state: { printing },
              });
            }
          } else {
            history.push({
              pathname: `/reportDoppler/${eco?.CODECO}`,
              state: { printing },
            });
          }
        } else {
          toast.warn('Laudo não Liberado para Internet!');
        }
      } else {
        toast.warn('Visualização não permitida. Consulte a administração!');
      }
    } catch (error) {
      toast.error('Erro ao carregar laudo!');
    } finally {
      setLoadingAtividadeId(null);
    }
  }

  function handleCarotida(atividade, printing = false) {
    if (!atividade.GUIA1 === 'SIM') return toast.warn('Laudo não autorizado!');

    history.push({
      pathname: `/report-carotida/${atividade.CODLAUDO}`,
      state: { printing },
    });
  }

  function handleFetal(atividade) {
    if (atividade.GUIA1 === 'SIM') {
      // SANTA CASA
      history.push('/form-fetal', { codLaudo: atividade.CODLAUDO });
    } else {
      toast.warn('Laudo não autorizado!');
    }
  }

  return (
    <>
      <Card style={{ marginTop: 10 }}>
        <Card.Header className="d-flex justify-content-between align-items-center">
          {!isMedicoExterno(medico) && (
            <Button size="sm" onClick={() => history.push('/agenda')}>
              <FaArrowLeft />
            </Button>
          )}
          <h5 className="m-0 text-success">EXAMES DO PACIENTE</h5>
        </Card.Header>
        <Card.Body>
          <div className="d-flex align-items-end">
            <div style={{ flex: '2 1 0%', marginRight: 10 }}>
              <Form.Label className="font-weight-bold mb-0">Nome</Form.Label>
              <Form.Control
                style={{ textTransform: 'uppercase' }}
                value={nomePac}
                required
                type="text"
                onChange={e => setNomePac(e.target.value)}
                onKeyUp={e => e.key === 'Enter' && handleBuscarPacientes()}
              />
            </div>
            <div style={{ flex: '1 1 0%', minWidth: '180px', marginRight: 10 }}>
              <Form.Label className="font-weight-bold mb-0">CPF</Form.Label>
              <Form.Control
                value={cpf}
                type="text"
                onChange={e => setCpf(e.target.value)}
                onKeyUp={e => e.key === 'Enter' && handleBuscarPacientes()}
              />
            </div>
            <div style={{ flex: '1 1 0%', minWidth: '180px', marginRight: 10 }}>
              <Form.Label className="font-weight-bold mb-0">
                Data de Nascimento
              </Form.Label>
              <Form.Control
                value={dtnNasc}
                type="date"
                onChange={e => setDtnNasc(e.target.value)}
                onKeyUp={e => e.key === 'Enter' && handleBuscarPacientes()}
                onPaste={e => {
                  const clipboard = e.clipboardData.getData('text').trim();
                  let match = clipboard.match(
                    /^(\d{2})[/.-](\d{2})[/.-](\d{4})$/
                  );
                  if (match) {
                    e.preventDefault();
                    const [, dd, mm, yyyy] = match;
                    setDtnNasc(`${yyyy}-${mm}-${dd}`);
                    return;
                  }
                  match = clipboard.match(/^(\d{4})[/.-](\d{2})[/.-](\d{2})$/);
                  if (match) {
                    e.preventDefault();
                    setDtnNasc(clipboard);
                  }
                }}
              />
            </div>
            <div style={{ flex: '0 0 auto' }}>
              <Button onClick={handleBuscarPacientes} disabled={isLocalizando}>
                {isLocalizando ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  'Localizar'
                )}
              </Button>
            </div>
          </div>

          {pacientes.length > 0 && !search && (
            <Table
              bordered
              hover
              size="sm"
              variant="success"
              style={{ marginTop: 10 }}
            >
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>Dt Nasc</th>
                  {medico?.tipo === 'Agenda' && <th>Celular</th>}
                  {medico?.tipo === 'Agenda' && <th>CPF</th>}
                  <th>Código</th>
                  <th>Opções</th>
                </tr>
              </thead>
              <tbody>
                {pacientes.map(pac => (
                  <tr key={pac.CODPAC}>
                    <td>
                      <Button
                        variant="link"
                        onClick={() =>
                          handleAtividades({
                            CODPAC: pac.CODPAC,
                            NOMEPAC: pac.NOMEPAC,
                          })
                        }
                      >
                        {pac.NOMEPAC}
                      </Button>
                    </td>
                    <td>{pac.dataFormatada}</td>
                    {medico?.tipo === 'Agenda' && <td>{pac.CELULARPAC}</td>}
                    {medico?.tipo === 'Agenda' && <td>{pac.ENDMARPAC}</td>}
                    <td>{pac.CODPAC}</td>
                    {medico?.tipo === 'Agenda' ? (
                      <td className="text-center">
                        <Button
                          variant="success"
                          disabled={loadingPacienteId === pac.CODPAC}
                          onClick={() =>
                            handleAtividades({
                              CODPAC: pac.CODPAC,
                              NOMEPAC: pac.NOMEPAC,
                            })
                          }
                        >
                          {loadingPacienteId === pac.CODPAC ? (
                            <Spinner
                              animation="border"
                              size="sm"
                              role="status"
                              aria-label="Carregando exames"
                            />
                          ) : (
                            'Exames'
                          )}
                        </Button>{' '}
                        <Button
                          variant="info"
                          onClick={() => {
                            setPacienteSelecionado(pac.CODPAC);
                            setShowPaciente(true);
                          }}
                        >
                          Paciente
                        </Button>
                      </td>
                    ) : (
                      <td style={{ textAlign: 'center' }}>
                        <Button
                          variant="success"
                          disabled={loadingPacienteId === pac.CODPAC}
                          onClick={() =>
                            handleAtividades({
                              CODPAC: pac.CODPAC,
                              NOMEPAC: pac.NOMEPAC,
                            })
                          }
                        >
                          {loadingPacienteId === pac.CODPAC ? (
                            <Spinner
                              animation="border"
                              size="sm"
                              role="status"
                              aria-label="Carregando exames"
                            />
                          ) : (
                            'Exames'
                          )}
                        </Button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>

      {search && (
        <Table
          bordered
          hover
          size="sm"
          variant="success"
          style={{ marginTop: 10 }}
        >
          <thead>
            {!isMedicoExterno(medico) ? (
              <tr>
                <th>Procedimento</th>
                <th>Convênio</th>
                <th>Data</th>
                <th>Laudo</th>
                <th>Realizou</th>
                <th>Guia</th>
                <th>Valor</th>
                <th>Laudado</th>
                <th>Fatura</th>
                <th>PDF</th>
                <th>Opções</th>
              </tr>
            ) : (
              <tr>
                <th>Procedimento</th>
                <th>Convênio</th>
                <th>Data</th>
                <th>Laudo</th>
              </tr>
            )}
          </thead>
          <tbody>
            {!isMedicoExterno(medico)
              ? atividades.map(a => (
                <tr key={a.CODFATURA}>
                  {a.CODPROCEDI === 1 ||
                    a.CODPROCEDI === 58 ||
                    a.CODPROCEDI === 800 ? (
                    <td>{a.DESCPROCEDI}</td>
                  ) : a.CODPROCEDI === 13 ? (
                    <td>{a.DESCPROCEDI}</td>
                  ) : a.CODPROCEDI === 14 || a.CODPROCEDI === 15 ? (
                    <td>{a.DESCPROCEDI}</td>
                  ) : a.CODPROCEDI === 17 ? (
                    <td>{a.DESCPROCEDI}</td>
                  ) : a.CODPROCEDI === 3 ? (
                    <td>{a.DESCPROCEDI}</td>
                  ) : a.CODPROCEDI === 4 ? (
                    <td>{a.DESCPROCEDI}</td>
                  ) : a.CODPROCEDI === 12 ? (
                    <td>{a.DESCPROCEDI}</td>
                  ) : a.CODPROCEDI === 11 ||
                    a.CODPROCEDI === 712 ||
                    a.CODPROCEDI === 713 ||
                    a.CODPROCEDI === 714 ? (
                    <td>{a.DESCPROCEDI}</td>
                  ) : a.CODPROCEDI === 7 ? (
                    <td>{a.DESCPROCEDI}</td>
                  ) : a.CODPROCEDI === 6 ? (
                    <td>{a.DESCPROCEDI}</td>
                  ) : (
                    <td>{a.DESCPROCEDI}</td>
                  )}
                  <td>{a.SIGLACONV}</td>
                  <td>{a.dataFormatada}</td>
                  <td>{a.CODLAUDO}</td>
                  <td className="m-0 p-0">{a.CODREALIZOU}</td>
                  <td className="m-0 p-0">{a.GUIA}</td>
                  <td className="m-0 p-0">{a.VLRLAUDO}</td>
                  <td className="m-0 p-0 text-center">
                    {' '}
                    <Badge
                      pill
                      variant={getStatusBadgeVariant(a.GUIA1, 'GUIA1')}
                    >
                      {a.GUIA1}
                    </Badge>
                  </td>
                  <td className="m-0 p-0">{a.CODFATURA}</td>
                  <td className="m-0 p-0 text-center">
                    {' '}
                    <Badge
                      pill
                      variant={getStatusBadgeVariant(
                        a.PDF_STATUS,
                        'PDF_STATUS'
                      )}
                    >
                      {a.PDF_STATUS}
                    </Badge>
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    {loadingAtividadeId === a.CODLAUDO ? (
                      <Spinner
                        animation="border"
                        size="sm"
                        role="status"
                        aria-label="Carregando laudo"
                      />
                    ) : (
                      <Dropdown>
                        <Dropdown.Toggle variant="success" size="sm">
                          Opções
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {a.CODPROCEDI === 11 ||
                            a.CODPROCEDI === 712 ||
                            a.CODPROCEDI === 713 ||
                            a.CODPROCEDI === 714 ? (
                            <>
                              <Dropdown.Item onClick={() => handleLaudar(a)}>
                                Laudar Eco
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => handleLaudarCongenitoTXT(a)}
                              >
                                Laudar Congênito TXT
                              </Dropdown.Item>
                            </>
                          ) : (
                            <Dropdown.Item onClick={() => handleLaudar(a)}>
                              Laudar
                            </Dropdown.Item>
                          )}
                          {a.CODPROCEDI === 3 ? (
                            <Dropdown.Item
                              onClick={() =>
                                history.push(`/formEcg/${a.CODLAUDO}`)
                              }
                            >
                              Anexar ECG
                            </Dropdown.Item>
                          ) : (
                            <Dropdown.Item
                              onClick={() => {
                                setAtividade(a);
                                setShowUpload(true);
                              }}
                            >
                              Anexar Arquivo
                            </Dropdown.Item>
                          )}
                          {a.CODPROCEDI === 1 ||
                            a.CODPROCEDI === 58 ||
                            a.CODPROCEDI === 800 ? (
                            <Dropdown.Item
                              onClick={() => {
                                setAtividade(a);
                                setShowReceitaModal(true);
                              }}
                            >
                              Emitir Receita
                            </Dropdown.Item>
                          ) : null}
                          {a.CODPROCEDI === 11 ||
                            a.CODPROCEDI === 712 ||
                            a.CODPROCEDI === 713 ||
                            a.CODPROCEDI === 714 ? (
                            <>
                              <Dropdown.Item
                                onClick={() => handleImprimir(a, false)}
                              >
                                Imprimir
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => handleImprimir(a, true)}
                              >
                                Imprimir Timbrado
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => handleImprimirTXT(a)}
                              >
                                ImprimirTXT
                              </Dropdown.Item>
                            </>
                          ) : (
                            <>
                              <Dropdown.Item
                                onClick={() => handleImprimir(a, false)}
                              >
                                Imprimir
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => handleImprimir(a, true)}
                              >
                                Imprimir Timbrado
                              </Dropdown.Item>
                            </>
                          )}
                        </Dropdown.Menu>
                      </Dropdown>
                    )}
                  </td>
                </tr>
              ))
              : atividades.map(a =>
                dbatividade.convenios.some(c => c.codConv === a.CODCONV) ? (
                  dbatividade.procedimentos.some(
                    p => p.codProcedi === a.CODPROCEDI
                  ) ? (
                    <tr key={a.CODFATURA}>
                      {a.CODPROCEDI === 11 ||
                        a.CODPROCEDI === 712 ||
                        a.CODPROCEDI === 713 ||
                        a.CODPROCEDI === 714 ? (
                        <td>
                          <Button variant="link" onClick={() => handleEco(a)}>
                            {a.DESCPROCEDI}
                          </Button>
                        </td>
                      ) : a.CODPROCEDI === 13 ? (
                        <td>
                          <Button
                            variant="link"
                            onClick={() => handleStress(a)}
                          >
                            {a.DESCPROCEDI}
                          </Button>
                        </td>
                      ) : a.CODPROCEDI === 12 ? (
                        <td>
                          <Button
                            variant="link"
                            onClick={() => handleTrans(a)}
                          >
                            {a.DESCPROCEDI}
                          </Button>
                        </td>
                      ) : (
                        <td>{a.DESCPROCEDI}</td>
                      )}
                      <td>{a.SIGLACONV}</td>
                      <td>{a.dataFormatada}</td>
                      <td>{a.CODLAUDO}</td>
                    </tr>
                  ) : null
                ) : null
              )}
          </tbody>
        </Table>
      )}

      <Modal show={showUpload} centered onHide={handleCloseModal}>
        <Modal.Header closeButton className="font-weight-bold">
          Anexar arquivo no laudo {atividade?.CODLAUDO}
        </Modal.Header>
        <Modal.Body>
          <CustomFileInput
            id="file-upload"
            label="Selecionar arquivo"
            multiple={atividade?.CODLAUDO === 3 ? false : true}
            onChange={e => setFiles(Array.from(e.target.files))}
          />
          <ul>
            {files?.map((file, idx) => (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <li style={{ marginRight: 5 }}>{file.name}</li>
                <FaTrashAlt
                  onClick={() => setFiles(f => f.filter((_, i) => i !== idx))}
                  cursor="pointer"
                  style={{ color: 'red' }}
                />
              </div>
            ))}
          </ul>
        </Modal.Body>
        <Modal.Footer>
          {isUploading ? (
            <Spinner animation="border" variant="dark" />
          ) : (
            <Button onClick={confirmUpload}>Confirmar</Button>
          )}
        </Modal.Footer>
      </Modal>

      <Modal show={showReceitaModal} size="xl">
        <Modal.Header className="font-weight-bold">
          RECEITUÁRIO MÉDICO
        </Modal.Header>
        <Modal.Body>
          <ReceituarioMedico
            closeModal={() => setShowReceitaModal(false)}
            codPaciente={atividade?.CODPAC}
            codConsulta={atividade?.CODLAUDO}
          />
        </Modal.Body>
      </Modal>

      {/*  TODO: isso tá um lixo! precisa clicar 2 vezes pra ver dados de outro paciente */}
      <Modal
        show={showPaciente}
        onHide={() => setShowPaciente(false)}
        size="xl"
      >
        <Modal.Body>
          <PacienteInfo
            key={pacienteSelecionado}
            codPac={pacienteSelecionado}
            onAbrirPaciente={pac => setPacienteSelecionado(pac.CODPAC)}
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
